export enum Entities {
  MILKRUN_ID = 8,
  WAREHOUSE_ID = 11,
}

export enum Roles {
  SELLER_ROLE = "SELLER_MANAGER",
  DELIVERY_ROLE = "ENTREPOT_RAMASSAGE",
  WAREHOUSE_ROLE = "ENTREPOT_PICKER",
  HUB_ROLE = "AGENT_HUB_REPRISE",
  EXPEDITION_ROLE = "RESPO_EXPEDITION_REPRISE",
}

export enum ReturnStatus {
  DRAFT = 1,
  CREATED = 2,
  IN_DELIVERY = 3,
  RECEIVED_BY_SELLER = 4,
  RECEIVED_BY_HUB = 5,
  RECEIVED_BY_SELLER_VIA_DELIVERY = 6,
  RECEIVED_BY_SELLER_VIA_HUB = 7,
  CANCELED_BY_SELLER = 8,
  WAREHOUSE_RECEPTION = 9,
  SELLER_DISPUTE = 10,
  PENDING_SHIPMENT = 11,
}
